import type { AppRouter } from "@dmca/api/AppRouter";
import type { TRPCClient } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";

export const { TRPCProvider, useTRPC, useTRPCClient } =
    createTRPCContext<AppRouter>();

export type TRPCAppClient = TRPCClient<AppRouter>;

export { type AppRouter };
